import socialApiClient from "../helpers/services/social-api-client";
import {
  SocialDateFilters,
  SocialInteraction,
  SocialPage,
  SocialReport,
  SocialSummary,
  SocialTopic,
} from "./types";

const payload = <T>(response: { data: { payload: T } }) => response.data.payload;

export const socialIntelligenceApi = {
  summary: (companyId: string, filters: SocialDateFilters) =>
    socialApiClient()
      .get("social-intelligence/summary", { params: { companyId, ...filters } })
      .then(payload<SocialSummary>),
  sentiment: (companyId: string, filters: SocialDateFilters) =>
    socialApiClient()
      .get("social-intelligence/sentiment", { params: { companyId, ...filters } })
      .then(payload<any>),
  topics: (companyId: string, filters: SocialDateFilters) =>
    socialApiClient()
      .get("social-intelligence/topics", { params: { companyId, ...filters } })
      .then(payload<{ topics: SocialTopic[] }>),
  interactions: (companyId: string, params: Record<string, any>) =>
    socialApiClient()
      .get("social-intelligence/interactions", { params: { companyId, ...params } })
      .then(payload<SocialPage>),
  opportunities: (companyId: string, filters: SocialDateFilters) =>
    socialApiClient()
      .get("social-intelligence/opportunities", { params: { companyId, ...filters } })
      .then(payload<SocialPage>),
  risks: (companyId: string, filters: SocialDateFilters) =>
    socialApiClient()
      .get("social-intelligence/risks", { params: { companyId, ...filters } })
      .then(payload<any>),
  jobsStatus: (companyId: string) =>
    socialApiClient()
      .get("social-intelligence/jobs/status", { params: { companyId } })
      .then(payload<any>),
  detail: (companyId: string, id: number) =>
    socialApiClient()
      .get(`social-intelligence/interactions/${id}`, { params: { companyId } })
      .then(payload<any>),
  patchInteraction: (companyId: string, id: number, changes: Partial<SocialInteraction>) =>
    socialApiClient()
      .patch(`social-intelligence/interactions/${id}`, changes, { params: { companyId } })
      .then(payload<any>),
  reanalyze: (companyId: string, id: number, reason?: string) =>
    socialApiClient()
      .post(`social-intelligence/interactions/${id}/reanalyze`, { reason }, { params: { companyId } })
      .then(payload<any>),
  requestSummary: (companyId: string, filters: SocialDateFilters) =>
    socialApiClient()
      .post(
        "social-intelligence/analyst/summary",
        { dateFrom: filters.dateFrom, dateTo: filters.dateTo },
        { params: { companyId } }
      )
      .then(payload<{ report: SocialReport }>),
  report: (companyId: string, id: number) =>
    socialApiClient()
      .get(`social-intelligence/analyst/summary/${id}`, { params: { companyId } })
      .then(payload<SocialReport>),
};
